import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { ProgrammingEventService } from './../../common/services/event.service';
import { SharedProgrammingService } from './../../common/services/shared-programming.service';

@Component({
  selector: 'prg-advanced-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less'],
  providers: []
})
export class ProgrammingListComponent implements OnInit {
  eventList: Observable<Array<any>>;
  searchText: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<any>,
    private shared: SharedProgrammingService,
    private eventService: ProgrammingEventService
  ) {
    this.eventList = this.store.select(s => s.programmingEvents.allEvents);
  }

  ngOnInit() {
    console.log('advanced list: oninit');
  }

  navigateToEvent(event: any) {
    if (event) {
      this.eventService.selectEvent(event).then(
        res => {
          this.router.navigate(['../device', event.deviceId, 'event', event.eventId], { relativeTo: this.route });
        },
        err => {
          console.warn('prg-lst: unable to select event', event, err);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/list/list.component.ts